import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "activity-item"
};
var _hoisted_2 = {
  class: "album-item"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "num"
};
var _hoisted_6 = {
  key: 1,
  class: "check-box"
};
var _hoisted_7 = {
  class: "activity-content"
};
var _hoisted_8 = ["title"];
var _hoisted_9 = {
  class: "time"
};
import { env_name } from '@/util/util.js';
import { watch, ref } from 'vue';
import { giveLike } from '@/api/personalHomepage';
export default {
  __name: 'activityItem',
  props: {
    data: {
      type: Object,
      default: function _default() {}
    },
    spaceHideFlag: {
      type: Number,
      default: 0
    },
    isCheckModule: {
      type: Boolean,
      default: false
    },
    clickRightValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['like', 'changeFlag'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var whiteStar = require('@/assets/home/white-star.svg');
    var redStar = require('@/assets/home/red-star.svg');
    // 查看详情
    var commonName = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : '//edu-course.zhixuehuijiao.cn';

    // 查看详情
    var lookDetail = function lookDetail(val) {
      var commonName = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : '//web.zhixuehuijiao.cn';
      window.open("".concat(commonName, "/activity?activity=%2FactivityDetail%3FactivityId%3D").concat(val.id));
    };

    // 点赞
    var handleLikeClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var id, isLike, opType, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              id = val.id, isLike = val.isLike;
              _context.p = 1;
              opType = isLike === 0 ? 1 : 0;
              _context.n = 2;
              return giveLike(id, 6, opType);
            case 2:
              emit('like', 'active');
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function handleLikeClick(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    // 新增计算属性和watcher
    var props = __props;
    var flag = ref(false);
    var disable = ref(false);
    watch(function () {
      return props;
    }, function (val) {
      var data = val.data,
        spaceHideFlag = val.spaceHideFlag;
      if (spaceHideFlag == 1) {
        //1隐藏
        flag.value = data.spaceHideFlag === 1 ? true : false;
        disable.value = data.spaceHideFlag === 1 ? true : false;
      } else {
        //0公开
        flag.value = data.spaceHideFlag === 0 ? true : false;
        disable.value = data.spaceHideFlag === 0 ? true : false;
      }
    }, {
      deep: true,
      immediate: true
    });
    var handleChange = function handleChange(val) {
      console.log(val, '--handleChange');
      emit('changeFlag', props.data.id);
    };
    return function (_ctx, _cache) {
      var _component_t_checkbox = _resolveComponent("t-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        class: "img",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return lookDetail(__props.data);
        }),
        src: __props.data.cover,
        width: "100%",
        height: "100%",
        alt: ""
      }, null, 8, _hoisted_3), !__props.isCheckModule ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "num-box",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return handleLikeClick(__props.data);
        })
      }, [_createElementVNode("img", {
        src: __props.data.isLike === 0 ? _unref(redStar) : _unref(whiteStar),
        alt: ""
      }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(__props.data.likeCount), 1)])) : _createCommentVNode("", true), __props.isCheckModule && __props.clickRightValue === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_t_checkbox, {
        modelValue: flag.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return flag.value = $event;
        }),
        disabled: disable.value,
        onChange: handleChange
      }, null, 8, ["modelValue", "disabled"])])) : _createCommentVNode("", true), __props.clickRightValue === 1 ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(['tip', __props.data.spaceHideFlag === 1 ? 'hide' : 'open'])
      }, _toDisplayString(__props.data.spaceHideFlag === 1 ? '已隐藏' : '已公开'), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", {
        class: "title",
        title: __props.data.name
      }, _toDisplayString(__props.data.name), 9, _hoisted_8), _createElementVNode("p", _hoisted_9, _toDisplayString(__props.data.time), 1)])]);
    };
  }
};